import { RequestApi, RequestApiUri } from 'vrlcm-gui-api';
import {
  GroupMetadata,
  Request,
  RequestName,
  RequestType,
  VcfInfraData,
  VcfInfraErrorData,
  VcfInfraSuccessData
} from 'vrlcm-gui-types';
import { Http, safeJsonParse } from 'vrlcm-gui-utils';
import { ValidateScaleOutOvaResult } from '../../../components/environments/actions/pre-add-component-alert/types';
import {
  GET_INFRA_METADATA_URL,
  GET_SCALEOUT_VALIDATION_URL
} from '../../../constants/ApiUri';
import { PRODUCT_MAPPING } from '../../../constants/AppConstants';

export default class InfrastructureStepAPI {
  public static getInfrastructureMetadata = async (): Promise<
    GroupMetadata[]
  > => {
    const response = await Http.get(GET_INFRA_METADATA_URL);
    return response.data;
  };

  public static getPropertiesFromVcf = async (
    productId: string
  ): Promise<VcfInfraData | undefined> => {
    return Http.post<Request>(RequestApiUri.REQUESTS_URL, {
      inputMap: {
        productId:
          productId === 'vidm'
            ? 'WSA'
            : ['vssc', 'vro'].includes(productId)
            ? 'VRA'
            : productId.toUpperCase()
      },
      requestReason: `Fetch infrastructure details from SDDC Manager for ${PRODUCT_MAPPING[productId]} deployment`,
      requestName: RequestName.VcfInfraDetailsCollection,
      requestType: RequestType.VCF_INFRA_DETAILS_COLLECTION
    } as Partial<Request>).then(req =>
      RequestApi.pollRequestForCompletionAndExtractEngineResult<VcfInfraData>(
        req.data.vmid
      ).then(res => {
        if (res.result) {
          const successData = res.result as VcfInfraSuccessData;
          const errorData = res.result as VcfInfraErrorData;
          if (successData.vCenterHost && successData.gateway) {
            return res.result;
          } else if (errorData.errorCode) {
            return res.result;
          } else {
            return undefined;
          }
        } else {
          return undefined;
        }
      })
    );
  };

  public static getValidateScaleOutOvaResult = (
    environmentId: string,
    productId: string,
    productVersion: string
  ) => {
    const body = {
      environmentId,
      productId,
      productVersion
    };
    return Http.post(GET_SCALEOUT_VALIDATION_URL, body).then(req =>
      RequestApi.pollRequestForCompletion(req.data.requestId).then(res => {
        const resultSet = safeJsonParse(res.resultSet)[0];
        return safeJsonParse<ValidateScaleOutOvaResult>(resultSet.resultText);
      })
    );
  };
}
